import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=741f1c74&scoped=true&"
import script from "../js/billings.js?vue&type=script&lang=js&"
export * from "../js/billings.js?vue&type=script&lang=js&"
import style0 from "./Billings.vue?vue&type=style&index=0&id=741f1c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f1c74",
  null
  
)

export default component.exports